import * as React from 'react';
import { compose, withHandlers, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { TableColumn } from 'logic/reports/ReportSettings';
import { Fragment } from 'react';
import { getTextKeyForColumn } from 'logic/reports/getTextKeyForColumn';
import { ReportType } from 'types';
import { Select } from 'ui/shared/Select';
import { getColumnSortType } from 'logic/reports/reportType';

export type OwnProps = {
    reportType: ReportType;
    groupIndex: number;
    selectedColumn: string | null;
    columns: ReadonlyArray<TableColumn>;
    onGroupChanged: (index: number, columnName: string | null) => void;
};

const RawColumnGroupControl = ({
    reportType,
    groupIndex,
    columns,
    selectedColumn,
    handleGroupChange,
    t,
}: OwnProps & TranslateProps & RecomposeProps) =>
    <Fragment>
        <label
            htmlFor={ `column-group-control-${groupIndex}` }
        >
            { t(groupIndex === 0 ? 'WC_REPORT_COLUMNS_GROUPBY' : 'WC_REPORT_COLUMNS_THENBY') }
        </label>
        <Select
            id={ `column-group-control-${groupIndex}` }
            value={ selectedColumn || '' }
            onChange={ handleGroupChange }
        >
            <option value="">{ t('6.5.0.25772.11') }</option>
            { columns.map(g =>
                <option key={ g.name } value={ g.name }>
                    { t(getTextKeyForColumn(reportType, g.name)) }
                </option>
            ) }
        </Select>
    </Fragment>
;

type RecomposeProps = {
    handleGroupChange: React.ChangeEventHandler<HTMLSelectElement>;
};

const filterEligibleColumns = (reportType: ReportType, columns: ReadonlyArray<TableColumn>, groupIndex: number) =>
    columns
        .filter(c => typeof c.groupIndex !== 'number' || c.groupIndex >= groupIndex)
        .filter(c => typeof c.visibleIndex === 'number')
        .filter(c => !!getColumnSortType(reportType, c.name)) // Don't allow grouping on an unsortable column
        .sort((a, b) => a.visibleIndex! - b.visibleIndex!)
;

export const ColumnGroupControl = compose<RecomposeProps & TranslateProps & OwnProps, OwnProps>(
    translate(),
    withProps<Partial<OwnProps>, OwnProps & TranslateProps>(({ reportType, selectedColumn, groupIndex, columns, t }) => ({
        columns: filterEligibleColumns(reportType, columns, groupIndex),
    })),
    withHandlers<OwnProps & RecomposeProps, RecomposeProps>({
        handleGroupChange: ({ groupIndex, onGroupChanged }) => (e: React.ChangeEvent<HTMLSelectElement>) => {
            const columnName = e.currentTarget.value;
            onGroupChanged(groupIndex, columnName ? columnName : null);
        },
    }),
)(RawColumnGroupControl);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/tableLayout/ColumnGroupControl.tsx